// Eine Statusangabe. Das Wort trägt die Bedeutung, die Farbe ist die Zugabe — niemand soll einen
// Zustand nur an einer Farbe erkennen müssen (parts4/00-contract.md).
import type { ReactElement, ReactNode } from 'react'
import './bausteine.css'

export type FahnenArt = 'neutral' | 'ok' | 'warnung' | 'alarm'

export interface FahneProps {
  art: FahnenArt
  children: ReactNode
}

export function Fahne({ art, children }: FahneProps): ReactElement {
  return (
    <span className="fahne" data-art={art}>
      {children}
    </span>
  )
}
